import request from "../request";
import Url from "../url/account";

const getUserList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getUserList + path, data, options);
};
const getUserListDeatils = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getUserListDeatils + path, data, options);
};
const updateAccountData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateAccountData + path, data, options);
};

export default {
  getUserList,
  getUserListDeatils,
  updateAccountData,
};
